// @flow
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ResetPasswordPage from 'common/modules/authentication/resetPassword/ResetPasswordPage';

import { resetPassword } from '../actions/authenticationActions';

import type { AppState } from '../../../types/State';

type Props = {
  isResetting: boolean,
  error: ?Object,
  actions: {
    resetPassword: (password: string, passwordValidation: string, token: string) => mixed,
  },

}
class StationResetPasswordPage extends Component<Props> {
  constructor(props: Props) {
    super(props);
    (this: any).resetPassword = this.resetPassword.bind(this);
  }

  async resetPassword(password: string, passwordValidation: string, token: string) {
    return await this.props.actions.resetPassword(password, passwordValidation, token);
  }

  render() {
    const { isResetting, error } = this.props;
    return (
      <ResetPasswordPage
        isResetting={isResetting}
        error={error}
        onResetPassword={this.resetPassword}
      />
    );
  }
}

function mapStateToProps(state: AppState) {
  return {
    isResetting: state.authentication.passwordReset.isResetting,
    error: state.authentication.passwordReset.error,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ resetPassword }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StationResetPasswordPage);



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/resetPassword/StationResetPasswordPage.js